import { Text } from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import React from 'react';
import { useSelector } from 'react-redux';

export default function OnlineButton(props) {
    const online = useSelector((state) => state.server.online)

    return (
        <>
            {props.variant == 'outline' ?
                <Button {...props} disabled={!online} className={` ${online ? "border-primary-900" : "border-primary-400"} active:bg-secondary-100 flex-1 p-1 `}><Text className={` ${online ? "text-primary-900" : "text-primary-400"} text-lg `}>{props.children}</Text></Button>
                :
                <Button {...props} disabled={!online} className={` ${online ? "bg-primary-900" : "bg-primary-400"} flex-1 p-1 `}><Text className={` ${online ? "text-secondary-50" : "text-secondary-400"} text-lg `}>{props.children}</Text></Button>
            }
        </>
    );
}